/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  GraphicalTakeOffHousePlanSaveDto,
  GraphicalTakeOffHousePlanViewDto,
  GraphicalTakeOffPoint,
} from '@gh/builder-shared-data';
import { createArrayHelper } from '@gh/common-shared';
import { WithDirty } from '@gh/common-shared-data';
import { GraphicalTakeOffDataBoxVisibility, GraphicalTakeOffImageTransformPipeline } from './graphical-take-off.model';
import { GraphicalTakeOffTop, GraphicalTakeOffTopView, newPoint, newSize } from './top.model';

export type GraphicalTakeOffHousePlanView = WithDirty<GraphicalTakeOffHousePlanViewDto & {
  imageLoaded: boolean;
  snapGridLoaded: boolean;
  image: HTMLImageElement;
  imagePipeline: GraphicalTakeOffImageTransformPipeline;
  isScaled: boolean;
  viewCenter?: GraphicalTakeOffPoint;
  zoom: number;
}>;

export type GraphicalTakeOffViewInfo = {
  view: GraphicalTakeOffHousePlanView;
  tops: GraphicalTakeOffTop[];
  topViews: GraphicalTakeOffTopView[];
};

export type GraphicalTakeOffHousePlanSave = GraphicalTakeOffHousePlanSaveDto;

export const getGraphicalTakeOffHousePlanViewId = (view: GraphicalTakeOffHousePlanView) =>
  (view.hpViewId || view.jobViewId)!; // tslint:disable-line:no-non-null-assertion

export const graphicalTakeOffHousePlanViewArr = createArrayHelper(getGraphicalTakeOffHousePlanViewId);

// tslint:disable-next-line:max-line-length
export const graphicalTakeOffHousePlanViewFromDto = (dto: GraphicalTakeOffHousePlanViewDto): GraphicalTakeOffHousePlanView => {
  const scaleWidth = dto.picture && dto.picture.scaleWidth || 0;
  const scaleHeight = dto.picture && dto.picture.scaleHeight || 0;

  return {
    ...dto,
    imageLoaded: false,
    snapGridLoaded: false,
    image: <any>void 0,
    imagePipeline: <any>void 0,
    isScaled: scaleWidth > 0 && scaleHeight > 0,
    isDirty: false,
    zoom: 0,
  };
};

export const getGraphicalTakeOffViewImage = (view: GraphicalTakeOffHousePlanView) => view.image;
export const getGraphicalTakeOffViewImagePipeline = (view: GraphicalTakeOffHousePlanView) => view.imagePipeline;

export const getGraphicalTakeOffViewImageSize = (view: GraphicalTakeOffHousePlanView) =>
  newSize(view.image.width, view.image.height);

export const isGraphicalTakeOffImageTransformed = (view: GraphicalTakeOffHousePlanView): boolean => {
  const pipeline = getGraphicalTakeOffViewImagePipeline(view);
  return pipeline ? pipeline.transformations.length > 0 : false;
};

export type UserGTOPreferences = {
  overLay?: boolean;
  snapToPoint?: boolean;
  hideShowDataBoxes?: GraphicalTakeOffDataBoxVisibility;
};
